import { MOODLE_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

export const getConfiguredCourses = async (page, size) => {
  try {
    const query =
      page !== undefined && size !== undefined
        ? `?page=${page}&size=${size}`
        : '';
    const response = await _axios.get(`${MOODLE_PATH}/courses${query}`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getMoodleCourses = async () => {
  try {
    const response = await _axios.get(`${MOODLE_PATH}/courses/moodle-list`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const autoLinkMoodleMappings = async () => {
  try {
    const response = await _axios.post(`${MOODLE_PATH}/mappings/auto-link`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const createMandatoryCourse = async (payload) => {
  try {
    const response = await _axios.post(`${MOODLE_PATH}/courses`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateCourse = async ({ id, ...payload }) => {
  try {
    const response = await _axios.put(`${MOODLE_PATH}/courses/${id}`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getMyBlockingDecision = async () => {
  try {
    const response = await _axios.get(
      `${MOODLE_PATH}/compliance/blocking-decision`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const refreshEmployeeStatus = async (email) => {
  try {
    const response = await _axios.post(
      `${MOODLE_PATH}/compliance/refresh-employee-status?email=${email}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getMyComplianceStatus = async () => {
  try {
    const response = await _axios.get(`${MOODLE_PATH}/compliance/my-status`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const refreshMyComplianceStatus = async () => {
  try {
    const response = await _axios.post(
      `${MOODLE_PATH}/compliance/refresh-my-status`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getCourseExclusions = async (courseConfigId) => {
  try {
    const response = await _axios.get(
      `${MOODLE_PATH}/courses/${courseConfigId}/exclusions`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const createCourseExclusion = async (courseConfigId, payload) => {
  try {
    const response = await _axios.post(
      `${MOODLE_PATH}/courses/${courseConfigId}/exclusions`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const removeExclusion = async (courseConfigId, employeeId) => {
  try {
    const response = await _axios.delete(
      `${MOODLE_PATH}/courses/${courseConfigId}/exclusions/${employeeId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const bulkExcludeEmployees = async (courseConfigId, payload) => {
  try {
    const response = await _axios.post(
      `${MOODLE_PATH}/courses/${courseConfigId}/exclusions/bulk`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const bulkExcludeEmployeeFromCourses = async (payload) => {
  try {
    const response = await _axios.post(
      `${MOODLE_PATH}/courses/exclusions/bulk-employee`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getMoodleConfigs = async () => {
  try {
    const response = await _axios.get(`${MOODLE_PATH}/config/list`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const createMoodleConfig = async (payload) => {
  try {
    const response = await _axios.post(`${MOODLE_PATH}/config`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getCourseCompletionReports = async ({
  year,
  courseConfigId,
  state,
  employeeId,
  page,
  size,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append('year', year);
    if (courseConfigId) params.append('courseConfigId', courseConfigId);
    if (state) params.append('state', state);
    if (employeeId) params.append('employeeId', employeeId);
    if (page !== undefined) params.append('page', page);
    if (size !== undefined) params.append('size', size);

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await _axios.get(
      `${MOODLE_PATH}/reports/course-completion${query}`,
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getTeamComplianceStatus = async (
  page = 0,
  size = 20,
  state,
  employeeName,
) => {
  try {
    const params = new URLSearchParams({ page, size });
    if (state) params.append('state', state);
    if (employeeName) params.append('employeeName', employeeName);

    const response = await _axios.get(
      `${MOODLE_PATH}/reports/team-status?${params.toString()}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
